import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import BlogHero from './components/BlogHero';
import BlogContent from './components/BlogContent';

export default function BlogExpertVsGeneralist() {
  useEffect(() => {
    // Update meta tags
    document.title = 'Why Specialized Layout Contractors are Replacing the Generalist In-House Drafter | Dinari Designs';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Discover why Vancouver construction firms are choosing specialized AutoCAD experts over generalist drafters to avoid costly rework and site delays in BC formwork projects.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'AutoCAD formwork expert, BC construction specialist, layout contractor Vancouver, concrete sequencing, construction hiring challenges');
    }

    // Add Schema.org JSON-LD for Article
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: 'Why Specialized Layout Contractors are Replacing the "Generalist" In-House Drafter',
      description: 'Discover why Vancouver construction firms are choosing specialized AutoCAD experts over generalist drafters to avoid costly rework and site delays in BC formwork projects.',
      author: {
        '@type': 'Organization',
        name: 'Dinari Designs',
      },
      publisher: {
        '@type': 'Organization',
        name: 'Dinari Designs',
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.readdy.ai/image/f0c3f25d25166b296c2998ed1e07db56/4ed16d38f79ad8245b8fcfc88558374a.jfif',
        },
      },
      datePublished: '2026-01-25',
      dateModified: new Date().toISOString().split('T')[0],
    });

    if (!document.head.querySelector('script[data-schema="blog-expert-vs-generalist"]')) {
      script.setAttribute('data-schema', 'blog-expert-vs-generalist');
      document.head.appendChild(script);
    }

    return () => {
      const schemaScript = document.head.querySelector('script[data-schema="blog-expert-vs-generalist"]');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <BlogHero />
      <BlogContent />
      <Footer />
    </div>
  );
}
